module.exports = __webpack_public_path__ + "bg-4.png?368be2e6021e3e5176c862f784fd774e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-4.png
// module id = 9
// module chunks = 10